import { UI, Utils } from 'common';
import React from 'react';

const { InlineMessage } = UI;
const { Util } = Utils;

interface CancellationBannerProps {
	closeRequestedDate: string;
	nextBillingDate: string;
	isTrialAccount?: boolean;
}

const CancellationBanner = ({
	closeRequestedDate,
	nextBillingDate,
	isTrialAccount,
}: CancellationBannerProps) => {
	const accessEndDate = nextBillingDate?.length
		? nextBillingDate
		: closeRequestedDate;
	const formattedDate = accessEndDate
		? (Util as any).formatDateReadable(accessEndDate)
		: '';

	const text = (
		<>
			<strong>You'll lose access to your account on {formattedDate}.</strong>
			<br />
			{isTrialAccount ? (
				<>
					You'll stay logged in and have full access to your history, contacts,
					and prints until the last day of your risk-free trial on{' '}
					{formattedDate}. You can reactivate your account anytime before then
					by selecting any plan below. After that date, your data will be
					permanently deleted.
				</>
			) : (
				<>
					You'll stay logged in and have full access to your history, contacts,
					and prints until {formattedDate}. You can reactivate your account
					anytime before then by selecting any plan below. After that date, your
					data will be permanently deleted.
				</>
			)}
		</>
	);

	return (
		<InlineMessage
			className="subscription-plan-cancellation-banner"
			type="warning"
			dataqa="subscription-plan-cancellation-banner"
			text={text}
		/>
	);
};

export default CancellationBanner;
